import { dispatcher } from '@store';

export const service = {
  updateStore(data) {
    return function (dispatch) {
      Object.keys(data).forEach((module) => {
        dispatch(
          dispatcher(`UPDATE_${module.toUpperCase()}_MODULE`, data[module]),
        );
      });
    };
  },
  setInverterIdx(index) {
    return function (dispatch) {
      dispatch(
        dispatcher('UPDATE_SERVICE_MODULE', { currentInverterIdx: index }),
      );
    };
  },
  showComandsPopup(showState, popupPropsValue) {
    return function (dispatch) {
      dispatch(
        dispatcher('UPDATE_SERVICE_MODULE', {
          isShownCommandsPopup: showState,
          popupProps: popupPropsValue,
        }),
      );
    };
  },
  showNotesModal({ isNotesOpen, deviceId, deviceName }) {
    return function (dispatch) {
      dispatch(
        dispatcher('UPDATE_SERVICE_MODULE', {
          noteProps: {
            isNotesOpen: isNotesOpen,
            deviceId: deviceId,
            deviceName: deviceName,
          },
        }),
      );
    };
  },
  setActiveUnitSN(unitSN) {
    return function (dispatch) {
      dispatch(
        dispatcher('UPDATE_SERVICE_MODULE', { currentUnitDeviceId: unitSN }),
      );
    };
  },
  setActiveUnitName(unitName) {
    return function (dispatch) {
      dispatch(
        dispatcher('UPDATE_SERVICE_MODULE', { currentUnitName: unitName }),
      );
    };
  },
  setTimeMode(timeMode) {
    return function (dispatch) {
      dispatch(dispatcher('UPDATE_SERVICE_MODULE', { timeMode }));
    };
  },
};
